export const formatInitials = (firstName?: string, lastName?: string, defaultValue: string = ""): string => {
  const parts = [firstName?.[0], lastName?.[0]].filter((i) => !!i).map((s) => s?.toUpperCase())

  return parts.length ? parts.join("") : defaultValue
}
